import React, { useState, useEffect, useMemo } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import "./ClosedRequsetEdit.css";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import CommonTable from "../../components/CommonTable/CommonTable";
import { toast } from "react-toastify";

export const ClosedRequsetEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dataId, pageData, tab } = location.state || {};
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);

  const [formData, setFormData] = useState([]);

  const getFullData = async () => {
    if (dataId?.search_id) {
      const res = await get(`${URLS.CLOSEDREQUSET}${dataId?.search_id}`);

      if (res?.status === "success") {
        setFormData(res?.data || []);
        setTotalCount(res?.count || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    }
  };

  useEffect(() => {
    getFullData();
  }, [dataId]);

  const handleViewed = async () => {
    try {
      if (!dataId?.search_id) return;

      let res = await post(
        `${URLS.CLOSEDREQUSET}resolve/${dataId?.search_id}/`,
      );
      if (res?.status === "success") {
        toast.success(res?.message || "Marked as viewed successfully");
        navigate("/closed-requset", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to mark as viewed");
      }
    } catch (error) {
      console.error("Error marking as viewed:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "Delivery Partner ID",
        accessor: "id",
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Delivery Partner Name",
        accessor: "name",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Delivery Partner Mobile",
        accessor: "mobile",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
    ];

    return d;
  }, [page, formData]);

  return (
    <>
      <PageHeader
        title="Unaccepted Delivery Request"
        showBackButton={true}
        onBackClick={() =>
          navigate("/closed-requset", { state: { page: pageData || 1 } })
        }
      />
      <div className="help-edit-container">
        <div className="help-edit-form">
          <div className="form-row">
            <div className="form-group">
              <label>Booking ID</label>
              <input
                type="text"
                name="booking_id"
                value={formData?.booking_id || ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Date & Time</label>
              <input
                type="text"
                name="datetime"
                value={
                  moment(formData?.updated_at).format(
                    "DD-MM-YYYY hh:mm:ss A",
                  ) || ""
                }
                readOnly
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>User Amount</label>
              <input
                type="number"
                name="user_amount"
                value={formData?.user_amount ?? ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Pincode</label>
              <input
                type="number"
                name="pincode"
                value={formData?.pincode ?? ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Seller Name</label>
              <input
                type="text"
                name="food_owner_name"
                value={formData?.food_owner_name ?? ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Buyer Name</label>
              <input
                type="text"
                name="buyer_name"
                value={formData?.buyer_name ?? ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Seller Phone</label>
              <input
                type="number"
                name="food_owner_phone"
                value={formData?.food_owner_phone ?? ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Buyer Phone</label>
              <input
                type="number"
                name="buyer_phone"
                value={formData?.buyer_phone ?? ""}
                readOnly
              />
            </div>
          </div>

          {tab === 1 && (
            <div className="form-actions">
              <button
                type="button"
                className="btn-viewed"
                onClick={handleViewed}
              >
                Resolve
              </button>
            </div>
          )}

          <h4 className="mb-4">Requested Delivery Partners</h4>

          <CommonTable
            columns={columns}
            data={formData?.requested_delivery_partners || []}
            showPagination={false}
          />
        </div>
      </div>
    </>
  );
};
